import { Component, inject, Input, OnInit } from '@angular/core';
import { HeaderConfigurationComponent } from '../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import {
  IonButton,
  IonContent,
  ModalController,
} from '@ionic/angular/standalone';
import { LargedLinkComponent } from '../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { SwitchConfigurationComponent } from '../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../manager/edro-network-manager';
import { Pool, PoolAdditionalData } from '../../../../../../../apis/pool.api';
import { IProduct } from '../../../../IProduct';
import { P0003605DetectionFinBidonModalComponent } from '../../../P0003605/Modal/p0003605-detection-fin-bidon-modal/p0003605-detection-fin-bidon-modal.component';
import { P0003606DetectionFinBidonModalComponent } from '../../Modal/p0003606-detection-fin-bidon-modal/p0003606-detection-fin-bidon-modal.component';
import { P00039DataRxTxIndex } from '../../../P00039Sync';
import { P0003606SensContactEnum } from '../../Enum/P0003606SensContactEnum';
import { LabelConfigurationComponent } from '../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P0003605SensContactEnum } from '../../../P0003605/Enum/P0003605SensContactEnum';

@Component({
  selector: 'app-p0003606-installation-detecteur-fin-bidon',
  templateUrl: './p0003606-installation-detecteur-fin-bidon.component.html',
  styleUrls: ['./p0003606-installation-detecteur-fin-bidon.component.scss'],
  standalone: true,
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LargedLinkComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
    LabelConfigurationComponent,
  ],
})
export class P0003606InstallationDetecteurFinBidonComponent implements OnInit {
  private modalController: ModalController = inject(ModalController);
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() pool: Pool | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  async goDetectionModal(value: number) {
    if (value !== 99) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionPh_Installation,
        'iphISensContactFinBidon',
        value,
        null,
      );
      return;
    }

    const modal = await this.modalController.create({
      component: P0003606DetectionFinBidonModalComponent,
      componentProps: {
        title: 'P0003606.installation.contact',
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.InjectionPh_Installation,
        'iphISensContactFinBidon',
        data.value,
        null,
      );
    }
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003606SensContactEnum = P0003606SensContactEnum;
}
